interface NavItem {
  href: string;
  items?: NavItem[];
}

const findNavItem = (tree: NavItem, path: string): NavItem | null => {
  function search(items: NavItem[] | undefined, remainingPath: string): NavItem | null {
    if (!items || !remainingPath) return null

    const subItem = items.find(item => item.href === remainingPath)

    if (subItem) return subItem

    for (const item of items) {
      const found = search(item.items, remainingPath)
      if (found) return found
    }

    return null
  }

  return search(tree.items, path)
}

const findParentNavItem = (tree: NavItem, path: string): NavItem | null => {
  function search(parent: NavItem | null, items: NavItem[] | undefined, targetPath: string): NavItem | null {
    if (!items) return null

    for (const item of items) {
      const itemPath = new URL(item.href, 'https://sporza.be').pathname
      if (itemPath === targetPath) {
        const hasChildItemWithSamePath = item?.items?.some(subItem => {
          const subItemPath = new URL(subItem.href, 'https://sporza.be').pathname

          return subItemPath === targetPath
        })

        if (hasChildItemWithSamePath) {
          return item
        }

        return parent
      }
      const found = search(item, item.items, targetPath)
      if (found) {
        return found
      }
    }

    return null
  }

  return search(null, tree.items, path)
}

const findSiblingNavItems = (tree: NavItem, path: string): NavItem[] => {
  const parent = findParentNavItem(tree, path)

  if (!parent) return []

  return parent.items || []
}

export type {
  NavItem
}

export {
  findNavItem,
  findParentNavItem,
  findSiblingNavItems
}
